import { assets } from "@/content/assets";
import { siteDefaults } from "@/lib/site-config";

/** Default logo for receipt/certificate PDFs and previews. */
export function getDefaultDocumentLogoUrl(): string {
  return resolveAbsoluteAssetUrl(assets.logo);
}

/** Resolve a site asset path to an absolute URL for PDF/email templates. */
export function resolveAbsoluteAssetUrl(path: string): string {
  if (/^https?:\/\//i.test(path)) {
    return path;
  }
  const base = siteDefaults.url.replace(/\/$/, "");
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${base}${normalized}`;
}
